import localizeDate from "./localize-date";

const ELEMENT_SELECTOR = "[data-localize-date]";
const elements = Array.from(document.querySelectorAll(ELEMENT_SELECTOR));

if (elements.length) {
	elements.forEach((element)=>{
		new localizeDate(element);
	});
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/localize-date/index.js